import { CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from "react-router-dom";
import { PageWrapper, PageWrapperProps } from "../../common-ui/PageWrapper";

import { ProgramNetworkErrors, useProgramById } from "./programUtils";
import { useTrainingStages } from "../TrainingStages/trainingStagesAPI";

const pageDetails: PageWrapperProps = {
  className: "Program",
  headerText: "Program"
};

export const Program = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { program, status, error } = useProgramById(id);
  const { trainingStages } = useTrainingStages();

  if (status === "idle") {
    <PageWrapper {...pageDetails}>
      <h2>{t("Awaiting data...")}</h2>;
    </PageWrapper>;
  }

  if (status === "loading") {
    return (
      <PageWrapper {...pageDetails}>
        <CircularProgress />
      </PageWrapper>
    );
  }

  if (status === "failed" || error) {
    return (
      <PageWrapper {...pageDetails}>
        <h2>{t("Error")}</h2>
        <h3>{t(ProgramNetworkErrors.FetchProgramError)}</h3>
        {error && <p>{error}</p>}
      </PageWrapper>
    );
  }

  if (status === "succeeded" && !program) {
    return (
      <PageWrapper {...pageDetails}>
        <h2>{t(ProgramNetworkErrors.ProgramNotFound)}</h2>
      </PageWrapper>
    );
  }

  if (status === "succeeded" && program) {
    const trainingStageId = (program as any).trainingStageId as string | null | undefined;
    const trainingStageName = trainingStageId
      ? trainingStages.find((s) => s.id === trainingStageId)?.displayName
      : null;
    return (
      <PageWrapper {...pageDetails}>
        <ul>
          <li>ID: {program.id}</li>
          <li>Name: {program.name}</li>
          <li>Description: {program.description}</li>
          <li>
            Institution:{" "}
            {program.institution ? program.institution.name : "N/A"}
          </li>
          <li>Training Stage: {trainingStageName || "N/A"}</li>
          <li>
            Networks:{" "}
            {program.networks?.map((n) => n?.name).join(", ") || "None"}
          </li>
        </ul>
        <div>
          <button onClick={() => navigate(`/programs/${program?.id}/edit`)}>
            {t("Edit Program")}
          </button>
        </div>
      </PageWrapper>
    );
  }

  return null;
};
